import css from 'styled-jsx/css';
import { colors, typography } from '../../config/styles';

const styles = css`
  .btn {
    min-height: 25px;
    min-width: 25px;
    font-size: ${typography.base};
    border-radius: 50%;

    :hover {
      background-color: ${colors.gray.shade43};
    }

    :disabled {
      cursor: not-allowed;
      background-color: transparent;
      color: ${colors.gray.shade2};
    }
  }

  .dots {
    min-height: 25px;
    min-width: 25px;
    text-align: center;
  }

  .pagination-item {
    color: ${colors.black.shade10};

    &.active {
      color: #fff;
      background-color: ${colors.blue.shade3};
      height: 30px;
      width: 30px;

      &.tottus {
        background-color: ${colors.teal.shade1};
      }
      &.whitelabel {
        background-color: var(--primary-color);
      }
    }
  }

  .pagination-arrow {
    :disabled {
      background-color: transparent;
    }
  }
`;

export { styles };
